import { publicGet, publicGetBlob, publicPost } from '@/lib/publicFetch';
import type {
  PublicWidgetConfig,
  Slot,
  BookRequest,
  BookingConfirmation,
  SlotsQueryInput,
} from './types';

// Public booking client: no auth, no axios (CX-489). Paths are under /api/v1/public/booking.
const BASE = '/booking';

export function fetchWidgetConfig(
  embedToken: string,
  options: { preview?: boolean } = {},
): Promise<PublicWidgetConfig> {
  return publicGet<PublicWidgetConfig>(`${BASE}/${embedToken}/config`, options.preview ? { preview: '1' } : undefined);
}

export function fetchSlots(
  embedToken: string,
  params: SlotsQueryInput,
  options: { preview?: boolean } = {},
): Promise<Slot[]> {
  return publicGet<Slot[]>(
    `${BASE}/${embedToken}/slots`,
    options.preview ? { ...params, preview: '1' } : { ...params },
  );
}

export function submitBooking(
  embedToken: string,
  body: BookRequest,
  options: { preview?: boolean } = {},
): Promise<BookingConfirmation | null> {
  return publicPost<BookingConfirmation | null>(
    `${BASE}/${embedToken}/book`,
    body,
    options.preview ? { preview: '1' } : undefined,
  );
}

export function downloadPublicIcs(bookingId: string): Promise<Blob> {
  return publicGetBlob(`${BASE}/ics/${bookingId}`);
}

export async function cancelBooking(token: string): Promise<void> {
  await publicPost(`${BASE}/cancel/${token}`);
}
